export default __webpack_public_path__ + "static/media/us-az.b8bc74e5.svg";